import { render } from "./bindMobile.vue?vue&type=template&id=00722fc8&scoped=true"
import script from "./bindMobile.vue?vue&type=script&lang=js"
export * from "./bindMobile.vue?vue&type=script&lang=js"

import "./bindMobile.vue?vue&type=style&index=0&id=00722fc8&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00722fc8"]])

export default __exports__